__turbopack_context__.v({
  "divider": "Stepper-module-sass-module__u9b7fG__divider",
  "divider-narrow": "Stepper-module-sass-module__u9b7fG__divider-narrow",
  "stepper": "Stepper-module-sass-module__u9b7fG__stepper",
  "steps": "Stepper-module-sass-module__u9b7fG__steps",
});
